import './OnboardingPage.scss'

import { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { api } from '../../utils/api';
import { useCurrentUser } from '../../UserProvider';
import classNames from 'classnames';

import EmailVerification from './OnboardingSteps/EmailVerification';
import SpotifyConnect from './OnboardingSteps/SpotifyConnect';
import KickThingsOff from './OnboardingSteps/KickThingsOff';
import SetProfileLink from './OnboardingSteps/SetProfileLink';
import usePageTitle from "../../hooks/PageTitle";



export default function OnboardingPage() {
  usePageTitle("Onboarding");
  
  const { onboarding_step } = useParams();
  const { currentUser, setCurrentUser } = useCurrentUser();
  const navigate = useNavigate();
  const [canProceed, setCanProceed] = useState(false);

  useEffect(() => {
    const requiredSteps = ["kick_things_off", "email_verification", "set_profile_link"];
    setCanProceed(!requiredSteps.includes(onboarding_step));
  }, [onboarding_step]);

  useEffect(() => {
    if ( currentUser && onboarding_step === undefined ){
      navigate(`/onboarding/${currentUser.onboarding_route[currentUser.onboarding_step]}`, { replace: true });
      return;
    }

    if (!currentUser || onboarding_step === undefined) return;

    const index = currentUser.onboarding_route.indexOf(onboarding_step);
    if ( index !== currentUser.onboarding_step && index !== -1 ){
      setCurrentUser(prev => ({ ...prev, onboarding_step: index }));
      api.put(`/users/me`, {onboarding_step: index})
    }

  }, [currentUser, onboarding_step, navigate, setCurrentUser]);

  const handleBack = () => {
    if ( currentUser.onboarding_route[0] === onboarding_step ){
      return;
    }
    const index = currentUser.onboarding_route.indexOf(onboarding_step)
    navigate(`/onboarding/${currentUser.onboarding_route[index-1]}`);
  };

  const handleNext = (force = false) => {
    if (!force && !canProceed) {
      return;
    }

    if ( currentUser.onboarding_route.at(-1) === onboarding_step ) {
      setCurrentUser(prev => ({ ...prev, onboarding_done: true }));
      api.put(`/users/me`, {onboarding_done: true});
      navigate(`/a/${currentUser.display_name}`);
      return;
    }
    const index = currentUser.onboarding_route.indexOf(onboarding_step)
    navigate(`/onboarding/${currentUser.onboarding_route[index+1]}`);
  };

  const stepComponents = {
    email_verification: <EmailVerification setCanProceed={setCanProceed} handleNext={handleNext} />,
    spotify_connect:    <SpotifyConnect    setCanProceed={setCanProceed} handleNext={handleNext} />,
    kick_things_off:    <KickThingsOff     setCanProceed={setCanProceed} handleNext={handleNext} />,
    set_profile_link:   <SetProfileLink    setCanProceed={setCanProceed} handleNext={handleNext} />,
  };

  return (
    <div className='__onboarding'>
      <div className='header'>
        <Link to="/"><img className='group' src="/images/logo.png" alt="Papaya Logo" /></Link>
      </div>
      <div className='content'>
        {stepComponents[onboarding_step]}

        <div className='footer'>
          <button className={classNames('ppy-btn', 'ppy-btn-primary', {disabled: currentUser.onboarding_route.indexOf(onboarding_step) === 0})} onClick={handleBack}>
            Back
          </button>
          <button className={classNames('ppy-btn', 'ppy-btn-primary', {disabled: !canProceed})} onClick={handleNext}>
            {currentUser.onboarding_route.at(-1) === onboarding_step && 'Finish'}
            {currentUser.onboarding_route.at(-1) !== onboarding_step && 'Next'}
          </button>
        </div>
      </div>
    </div>
  );
}